import React, {useEffect, useState} from 'react';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {Button, Form, Input, Select, Row, App, Typography} from 'antd';
import {
    EyeInvisibleOutlined,
    EyeOutlined,
    WarningOutlined,
} from '@ant-design/icons';
import './Login.css';
import {MainImage} from "../../components/image/MainImage";
import {themeLocations} from "../../theme/themeLocations";
import MainLayout from "../../components/layout/MainLayout";
import {showApiError} from "../../utility/error/error-handler";
import {getDriverRouteById} from "../../components/routes/driverRoutes";
import {useTranslation} from "react-i18next";
import {updateForgottenPassword, updateResetPassword, updateCreateUser, verifyEmail, 
        getUserSecurityQuestions, validateUserQuestions} from "../../api/user";
import {getSecurityQuestions} from "../../api/config";
import HeaderBanner from "../../components/layout/HeaderBanner";
import useOnlineStatus from "../../utility/hooks/useOnlineStatus";

const { Title} = Typography;



// The root  component.
const SetPassword = () => {

    const { t } = useTranslation();

    const { isOnline } = useOnlineStatus();

    const { message, notification } = App.useApp();

    const navigate = useNavigate();

    const [searchParams] = useSearchParams();

    const [updateProgress, setUpdateProgress] = useState(100);  //start 100 - button shows loading if less than 100

    const [token, setToken] = useState(null);
    const [securityQuestions, setSecurityQuestions] = useState([]);
    const [validQuestions, setValidQuestions] = useState([]);
    const [userSecurityQuestions, setUserSecurityQuestions] = useState([]);
    const [askQuestions, setAskQuestions] = useState(false);
    const [showQuestions, setShowQuestions] = useState(false);
    const [answers, setAnswers] = useState({});

    const [textVisible1, setTextVisible1] = useState(false);
    const [textVisible2, setTextVisible2] = useState(false);
    const suffixIcon1 = textVisible1
        ? (<EyeInvisibleOutlined onClick={() => toggleFieldVisible(1, false)} />)
        : (<EyeOutlined onClick={() => toggleFieldVisible(1, true)} />);
    const fieldType1 = textVisible1 ? 'text' : 'password';
    const suffixIcon2 = textVisible2
        ? (<EyeInvisibleOutlined onClick={() => toggleFieldVisible(2, false)} />)
        : (<EyeOutlined onClick={() => toggleFieldVisible(2, true)} />);
    const fieldType2 = textVisible2 ? 'text' : 'password';

    const [questionProperties, setQuestionProperties] = useState([]);
    const [passwordValues, setPasswordValues] = useState({});
    
    const toggleFieldVisible = (index, visible) => 
    {
        console.log(passwordValues);
        let newValues = JSON.parse(JSON.stringify(passwordValues));
        setPasswordValues(newValues);
        if(index === 1)
        {
            setTextVisible1(visible);
        }
        else
        {
            setTextVisible2(visible);
        }
    }


    const onFinish = (values) => {
        if(isOnline)
        {
            console.log(values);
            // Check passwords match
            if (values.password !== values.repeat_password) {
                notification.open({
                    icon: <WarningOutlined style={{color: 'var(--dp-status-colour-warning)'}}/>,
                    description: t('error.passwords_not_same'),
                    duration: null,
                });
            }
            // Update password
            else {
                let useAnswers = answers;
                if(token.process === updateCreateUser)
                {
                    if(values.question1)
                    {
                        useAnswers = [];
                        useAnswers.push({key: values.question1, answer: values.answer1});
                        if(values.question2)
                        {
                            useAnswers.push({key: values.question2, answer: values.answer2});
                        }
                    }    
                }
                console.log(useAnswers);
                let parameters = {token: token.token, password: values.repeat_password};
                if(useAnswers.length > 0)
                {
                    parameters.answers = useAnswers;
                }
                console.log(parameters);
                token.process(parameters, setUpdateProgress)
                    .then(res => {
                        // No data returned - message success and navigate to login page
                        message.success(t('message.successfully_submitted', {0: t('field.password')}));
                        notification.destroy();
                        navigate(getDriverRouteById('start'));
                    })
                    .catch(err => {
                        const replaceCommaWithNewLine = (msg) => { return msg.replaceAll(',', "<br />") };
                        showApiError(null, err, notification, [], replaceCommaWithNewLine);
                    });
            }
        }
        else
        {
            notification.open({
                icon: <WarningOutlined style={{color: 'var(--dp-status-colour-warning)'}}/>,
                description: t('error.offline'),
                duration: null,
            });
        }

    };
    const onFinishFailed = (errorInfo) => {
        console.log('Form Failed:', errorInfo);
    };

    const onVerify = (values) => {
        if(isOnline)
        {
            const convertValues = (() => {
                return Object.keys(values).map((id) => {
                    return {key : id, answer : values[id]}
                });
            });
            console.log(convertValues());
            validateUserQuestions({token: token.token, answers: convertValues()}, setUpdateProgress)
                .then(res => {
                    // No data returned - allow new password to be set
                    setAskQuestions(false);
                    setAnswers(convertValues);
                })
                .catch(err => {
                    const replaceCommaWithNewLine = (msg) => { return msg.replaceAll(',', "<br />") };
                    showApiError(null, err, notification, [], replaceCommaWithNewLine);
                });
        }
        else
        {
            notification.open({
                icon: <WarningOutlined style={{color: 'var(--dp-status-colour-warning)'}}/>,
                description: t('error.offline'),
                duration: null,
            });
        }

    };

    const onVerifyFailed = (errorInfo) => {
        console.log('Form Failed:', errorInfo);
    };

    const updateProperties = (index) => {
        if(questionProperties[index])
        {
            let updatedProperties = [...questionProperties];
            if(updatedProperties[index].type === 'password')
            {
                updatedProperties[index].type = 'text';
            }
            else
            {
                updatedProperties[index].type = 'password';
            }
            setQuestionProperties(updatedProperties);
        }
    }

    useEffect(() => {
        let readToken = null;
        let process = null;
        console.log(searchParams);
        if(searchParams)
        {
            readToken = searchParams.get("password_forgot");
            if(!readToken)
            {
                readToken = searchParams.get("user_create");
                if(!readToken)
                {
                    readToken = searchParams.get("password_reset");
                    if(!readToken)
                    {
                        readToken = searchParams.get("email_verification");
                        if(readToken)
                        {    
                             process = verifyEmail;
                        }
                    }
                    else
                    {
                        process = updateResetPassword;
                    }
                }
                else
                {
                    process = updateCreateUser;
                }
            }
            else
            {
                process = updateForgottenPassword;
            }
        }
        console.log(readToken);
        console.log(process);
        if (!readToken) {
            console.error('password forgot token not passed in!');
            navigate(getDriverRouteById('missing'));
        } else {
            if(process === verifyEmail)
            {
                process({'token': readToken}, setUpdateProgress)
                .then(res => {
                    // No data returned - message success and navigate to login page
                    notification.destroy();
                    navigate(getDriverRouteById('start'));
                })
                .catch(err => {
                    const replaceCommaWithNewLine = (msg) => { return msg.replaceAll(',', "<br />") };
                    showApiError(null, err, notification, [], replaceCommaWithNewLine);
                });
            }
            else
            {
                setToken({'process' : process, 'token' : readToken});
            }
        }
    }, [searchParams, navigate, setToken, notification]);

    useEffect(() => {
        console.log(token);
        if(token)
        {
            if(token.process === updateForgottenPassword)
            {
                console.log("Forgotten Password");
                getUserSecurityQuestions(token)
                   .then(res => {
                       setUserSecurityQuestions(res);
                       setAskQuestions(res.length > 0);
                       setQuestionProperties(res.map((question) => {return {type : 'password', name : question.id}}))
                   })
                   .catch((err) => {
                       const replaceCommaWithNewLine = (msg) => { return msg.replaceAll(',', "<br />") };
                       showApiError(null, err, notification, [], replaceCommaWithNewLine);
                       setTimeout(function (){
                          navigate(getDriverRouteById('start'));           
                       }, 4000);
                   });
            }
            else if(token.process === updateCreateUser)
            {
                getSecurityQuestions().then(res => {
                    setSecurityQuestions(res);
                    setShowQuestions(res.length > 0);
                    let valid = [];
                    valid[1] = [...res];
                    if(res.length > 1)
                    {
                        valid[2] = [...res];
                    }
                    setValidQuestions(valid);
                });
            }
        }
    }, [token, navigate, notification])

    const getInitialValues = (source) =>
    {
        let initialValues = {};
        if(source === 'question')
        {
            questionProperties.forEach(item => {initialValues[item.name] = item.value});
        }
        else
        {
            initialValues = passwordValues;
        }
        return initialValues;
    }

    const setFieldValue = (index, value) => 
    {
        questionProperties[index].value = value;
    }

    const storePasswordValue = (name, value) => 
    {
        passwordValues[name] = value;
    }

    const getOptions = (field) => {
        return validQuestions[field].map(question => {return {value: question.id, label: question.description}});
    }

    const updateOptions = (field, questionId) => {
        let updated = [...validQuestions];
        if(!questionId)
        {
            updated[field] = [...securityQuestions];
        }
        else
        {
            updated[field] = [...securityQuestions.filter(question => question.id !== questionId)]
        }
        setValidQuestions(updated);
    }

    const SecurityQuestionsForm = () => {
        return (
            <Form
               className="login-form"
               name="sec-quest-dp"
               onFinish={onVerify}
               onFinishFailed={onVerifyFailed}
               autoComplete="off"
               layout="vertical"
               initialValues={getInitialValues('question')}
            >
              {userSecurityQuestions.map((question, index) => { return (
              <Form.Item
                name={question.id}
                label={question.description}
                rules={[
                    { required: true, message: t('error.no_value_named', {0: question.description}) },
                ]}
                style={{ marginTop: '-5px' }}
              >
                <Input
                  type={questionProperties[index].type}
                  placeholder={t('action.enter_value')}
                  maxLength={80}
                  suffix={questionProperties[index].type === 'password' ? <EyeInvisibleOutlined onClick={() => updateProperties(index)}/> : <EyeOutlined onClick={() => updateProperties(index)}/>}
                  onChange={e => setFieldValue(index, e.target.value)}
                />
              </Form.Item>)}
              )}
              <Form.Item>
                <Button style={{ marginTop: '15px' }} type="primary" htmlType="submit" block loading={updateProgress < 100}>
                    {t('action.submit')}
                </Button>
              </Form.Item>
            </Form>);
    }

    const NewPasswordForm = () => {
        return (
            <Form
               className="login-form"
               name="set-pwd-dp"
               onFinish={onFinish}
               onFinishFailed={onFinishFailed}
               autoComplete="off"
               layout="vertical"
               initialValues={getInitialValues('password')}
            >
              {
                showQuestions
                ?
                <>
                <Form.Item
                    name="question1"
                    label={t('field.security_question') + (securityQuestions.length > 1 ? ' 1' : '')}
                    rules={[
                        { required: true, message: t('error.no_value_named', {0: t('field.security_question') + (securityQuestions.length > 1 ? ' 1' : '')}) },
                    ]}
                   style={{ marginTop: '-5px' }}
                  >
                    <Select placeholder={t('action.select_value')} options={getOptions(1)} onChange={e => {storePasswordValue('question1', e); updateOptions(2, e)}}/>
                  </Form.Item>
                  <Form.Item
                    name="answer1"
                    rules={[
                        { required: true, message: t('error.no_value_named', {0: t('field.answer')}) },
                    ]}
                   style={{ marginTop: '-5px' }}
                  >
                    <Input
                      type='text'
                      placeholder={t('action.enter_value')}
                      maxLength={80}
                      onChange={e => storePasswordValue('answer1', e.target.value)} 
                    />
                  </Form.Item>
                  {
                    securityQuestions.length > 1
                    ?
                    <>
                      <Form.Item
                         name="question2"
                         label={t('field.security_question') + ' 2'}
                         rules={[
                            { required: true, message: t('error.no_value_named', {0: t('field.security_question') + ' 2'}) },
                         ]}
                         style={{ marginTop: '-5px' }}
                      >
                         <Select placeholder={t('action.select_value')} options={getOptions(2)} onChange={e => {storePasswordValue('question2', e); updateOptions(1, e)}}/>
                      </Form.Item>
                      <Form.Item
                        name="answer2"
                        rules={[
                            { required: true, message: t('error.no_value_named', {0: t('field.answer')}) },
                        ]}
                       style={{ marginTop: '-5px' }}
                      >
                        <Input
                          type='text'
                          placeholder={t('action.enter_value')}
                          maxLength={80}
                          onChange={e => storePasswordValue('answer2', e.target.value)} 
                        />
                      </Form.Item>                    
                    </>
                    :
                    <></>
                  }
                </>
                :
                <></>
              }
              <Form.Item
                name="password"
                label={t('field.password_new')}
                rules={[
                    { required: true, message: t('error.no_value_named', {0: t('field.password_new')}) },
                ]}
                style={{ marginTop: '-5px' }}
              >
                <Input
                  type={fieldType1}
                  placeholder={t('action.enter_value')}
                  maxLength={80}
                  suffix={suffixIcon1}
                  onChange={e => storePasswordValue('password', e.target.value)}
                />
              </Form.Item>

              <Form.Item
                 name="repeat_password"
                 label={t('field.password_confirm')}
                 rules={[
                    { required: true, message: t('error.no_value_named', {0: t('field.password_confirm')}) },
                 ]}
                 style={{ marginTop: '20px' }}
              >
                <Input
                  type={fieldType2}
                  placeholder={t('action.enter_value')}
                  maxLength={80}
                  suffix={suffixIcon2}
                  onChange={e => storePasswordValue('repeat_password', e.target.value)}
                />
              </Form.Item>

              <Form.Item>
                <Button style={{ marginTop: '15px' }} type="primary" htmlType="submit" block loading={updateProgress < 100}>
                    {t('action.submit')}
                </Button>
              </Form.Item>
            </Form>);
    }

    return (
        <MainLayout showHeader={false} showTabMenu={false} showSubHeader={true} startHigher="280px" subHeaderContent={<HeaderBanner />}>
            <Row type="flex" align="middle" justify="center">
                <div className="login-content">
                    <Row type="flex" justify="center" className="login-logo">
                        <MainImage imageSrc={themeLocations.MAIN_LOGO} />
                    </Row>
                    <Row type="flex" justify="center" className="login-logo">
                        <Title level={3}>{t('title.update_security_info')}</Title>
                    </Row>
                    <Row>
                        {askQuestions
                        ?
                        <SecurityQuestionsForm/>
                        :
                        <NewPasswordForm/>
                        }
                    </Row>
                </div>
            </Row>
        </MainLayout>
    );
}

export default SetPassword;
